// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2amJL","colMin":"styles_colMin__2w1_0","colCheckbox":"styles_colCheckbox__3Kd7Q"};